import React, { Component, useState } from 'react';

function ResourceCard({ title, icon, href }) {
  const [hovered, setHovered] = useState(false);
  const [active, setActive] = useState(false);

  return (
    <a
      href={href}
      style={{ textDecoration: 'none' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => { setHovered(false); setActive(false); }}
      onMouseDown={() => setActive(true)}
      onMouseUp={() => setActive(false)}
    >
      <div
        className="tiny-padding"
        style={{
          borderRadius: '8px',
          position: 'relative',
          minHeight: '100px',
          backgroundColor: active ? 'rgba(0, 110, 133, 0.12)' : hovered ? 'rgba(0, 110, 133, 0.08)' : 'transparent',
          boxShadow: hovered ? 'none' : '0 2px 8px rgba(0,0,0,0.12)',
          transform: hovered ? 'translateY(-4px)' : 'translateY(0)',
          transition: 'transform 0.2s ease, background-color 0.15s ease, box-shadow 0.2s ease',
          color: '#006E85',
        }}
      >
        <h6 style={{ margin: 0, textTransform: 'uppercase' }}>{title}</h6>
        <span
          className="material-symbols-rounded"
          style={{ position: 'absolute', bottom: '12px', right: '12px', fontSize: '20px', color: '#006E85' }}
        >
          {icon}
        </span>
      </div>
    </a>
  );
}

export default class OverviewSection extends Component {
  render() {
    return (
      <div id="hero">
        <div className="tiny-padding tiny-margin">
          <div
            style={{
              backgroundImage: 'url(/images/background-lines-gradient-purple.webp)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              borderRadius: '16px',
              height: '260px',
            }}
          />
        </div>
        <div className="max-width-container">
          <div className="small-padding">
            <h1 className="full-width primary-color-dark tiny-bottom-margin"><span className="primary-color-dark">{'Design that Empowers Product'}</span>&nbsp;<span>{'Teams'}</span></h1>
            <div className="full-width small-padding primary-background-subtle primary-color-dark" style={{borderRadius: '16px', display: 'flex', alignItems: 'center', gap: '12px'}}>
              <span className="material-symbols-rounded primary-color" style={{ fontSize: '32px', flexShrink: 0 }}>menu_book</span>
              <h5 style={{margin: 0}}><b>{'Resources, guidelines, and tools to help every team create consistent, on-brand work.'}</b></h5>
            </div>
            <div className="small-top-margin">
              <div className="row medium-padding no-left-padding no-right-padding" style={{ borderBottom: '1px solid rgba(0,0,0,0.1)' }}>
                <div className="small-12 medium-4 small-padding no-top-padding no-bottom-padding no-left-padding">
                  <h4 style={{ margin: 0 }}>{'Better Experiences = Trust in Data'}</h4>
                </div>
                <div className="small-12 medium-8 small-padding no-top-padding no-bottom-padding no-left-padding">
                  <p style={{ margin: 0 }}>{'At YipitData, design plays a critical role in transforming complex data into clear, compelling experiences our customers can act on. Whether you\'re building a report, a dashboard, or a client-facing asset, these shared systems and guidelines are here to support you.'}</p>
                </div>
              </div>
              <div className="row medium-padding no-left-padding no-right-padding" style={{ borderBottom: '1px solid rgba(0,0,0,0.1)' }}>
                <div className="small-12 medium-4 small-padding no-top-padding no-bottom-padding no-left-padding">
                  <h4 style={{ margin: 0 }}>{'A Shared Language for Increased Efficiency'}</h4>
                </div>
                <div className="small-12 medium-8 small-padding no-top-padding no-bottom-padding no-left-padding">
                  <p style={{ margin: 0 }}>{'Design is more than aesthetics — it\'s a shared language that enables teams to move faster and collaborate more efficiently. When we operate from a common visual foundation, decisions get easier, handoffs get smoother, and the end result speaks for itself. These standards exist not to constrain creativity, but to focus it. Great design, applied consistently, is how we build products that people love and trust.'}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="max-width-container">
          <div className="small-padding">
            <h4>{'Requests & Resources'}</h4>
            <p className="tiny-top-margin">{"Have a request or need something custom? Reach out to the design team (design@yipitdata.com) and wherever possible, lean on the shared design patterns in this library to keep work moving quickly and cohesively."}</p>
          </div>
          <div className="row small-padding no-top-padding medium-bottom-margin">
            <div className="small-6 medium-3 tiny-padding no-left-padding">
              <ResourceCard title="Submit a Request" icon="email" href="mailto:design@yipitdata.com" />
            </div>
            <div className="small-6 medium-3 tiny-padding no-left-padding">
              <ResourceCard title="Questions?" icon="email" href="mailto:design@yipitdata.com" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
